"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToRequestData = exports.getBusinessBrand = void 0;
var getBusinessBrand = function (brand) {
    switch (brand) {
        case 'fendt':
            return 'Fendt';
        case 'valtra':
            return 'Valtra';
        case 'massey':
            return 'Massey Ferguson';
        case 'agco':
        default:
            return 'AGCO';
    }
};
exports.getBusinessBrand = getBusinessBrand;
var mapAddressData = function (address) {
    var _a;
    return {
        addressLine1: address === null || address === void 0 ? void 0 : address.addressLine1,
        countryCode: address === null || address === void 0 ? void 0 : address.country,
        cityName: address === null || address === void 0 ? void 0 : address.city,
        stateProvinceName: (_a = address === null || address === void 0 ? void 0 : address.state) !== null && _a !== void 0 ? _a : '',
        postalCodeText: address === null || address === void 0 ? void 0 : address.postalCode,
        contactPointType: 'ContactPointAddress',
        primaryFlag: true,
        activeFromDate: new Date().toISOString().slice(0, 10),
    };
};
var mapToRequestData = function (data, consents, locale) {
    var _a, _b, _c, _d;
    if (locale === void 0) { locale = 'en_GB'; }
    var _e = data.data, address = _e.address, details = _e.details, email = _e.email, password = _e.password, phoneNumbers = _e.phoneNumbers, account = _e.account, _f = _e.brand, brand = _f === void 0 ? 'agco' : _f;
    if (!details || !email || !password) {
        throw new Error('Missing required data');
    }
    var firstName = details.firstName, lastName = details.lastName, salutation = details.salutation;
    var businessPhone = [];
    if ((phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.office) || (consents.viaTelephone && consents.officeNumber)) {
        businessPhone.push({
            contactPointType: 'ContactPointPhone',
            primaryFlag: true,
            telephoneNumber: (_a = phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.office) !== null && _a !== void 0 ? _a : consents.officeNumber,
            activeFromDate: new Date().toISOString().slice(0, 10),
        });
    }
    var mobilePhone = [];
    if ((phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.mobile) || (consents.viaSms && consents.mobileNumber)) {
        mobilePhone.push({
            contactPointType: 'ContactPointPhone',
            primaryFlag: true,
            telephoneNumber: (_b = phoneNumbers === null || phoneNumbers === void 0 ? void 0 : phoneNumbers.mobile) !== null && _b !== void 0 ? _b : consents.mobileNumber,
            activeFromDate: new Date().toISOString().slice(0, 10),
        });
    }
    var communicationSubscriptionConsents = [];
    var contactPointTypeConsents = [];
    var consentValues = ['MailingAddress', 'Email', 'Phone', 'SMS'];
    [consents.viaPostalService, consents.viaEmail, consents.viaTelephone, consents.viaSms].forEach(function (consent, consentIndex) {
        if (consent) {
            var consentValue = consentValues[consentIndex];
            var common = {
                captureSource: 'Multibrand Registration Form',
                captureDateTime: new Date().toISOString(),
            };
            communicationSubscriptionConsents.push(__assign(__assign({}, common), { businessBrand: (0, exports.getBusinessBrand)(brand), communicationSubscriptionType: 'Newsletter', commSubscriptionChannelType: consentValue, status: 'Opt In' }));
            contactPointTypeConsents.push(__assign(__assign({}, common), { contactPointType: consentValue, captureContactPointType: 'Web', status: 'Opt In' }));
        }
    });
    var authorizationFormConsents = [
        {
            authorizationForm: 'AGCO_Data_Privacy_Policy',
            captureSourceType: 'Web',
            captureDateTime: new Date().toISOString(),
            captureSource: 'Multibrand Registration Form',
            status: 'Seen',
        },
    ];
    if (communicationSubscriptionConsents.length > 0) {
        authorizationFormConsents.push({
            authorizationForm: 'Marketing_Consent',
            captureSourceType: 'Web',
            captureDateTime: new Date().toISOString(),
            captureSource: 'Multibrand Registration Form',
            status: 'Signed',
        });
    }
    return {
        individual: {
            salutation: salutation,
            firstName: firstName,
            lastName: lastName,
            locale: locale,
            communicationSubscriptionConsents: communicationSubscriptionConsents,
            contactPointTypeConsents: contactPointTypeConsents,
            authorizationFormConsents: authorizationFormConsents,
        },
        contactEmail: [
            {
                emailAddress: email,
                contactPointType: 'ContactPointEmail',
                primaryFlag: true,
                activeFromDate: new Date().toISOString().slice(0, 10),
            },
        ],
        businessPhone: businessPhone,
        mobilePhone: mobilePhone,
        mailingAddress: [mapAddressData(address)],
        account: __assign(__assign({}, account), { shippingAddress: (_c = account === null || account === void 0 ? void 0 : account.shippingAddress) === null || _c === void 0 ? void 0 : _c.map(mapAddressData), billingAddress: (_d = account === null || account === void 0 ? void 0 : account.billingAddress) === null || _d === void 0 ? void 0 : _d.map(mapAddressData) }),
        identity: {
            password: password,
        },
        accountContactRoles: [
            {
                isDirect: true,
                roles: ['Owner'],
            },
        ],
    };
};
exports.mapToRequestData = mapToRequestData;
